<template>
  <section class="section_base">
    <section-header
      :title="title"
      :description="description"
    >
      <template v-slot:right>
        <slot name="right"></slot>
      </template>
    </section-header>

    <div class="section_base--inner">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: "SectionBasic",
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    },
  }
}
</script>

<style lang="scss" scoped>
// See section.scss for section_base styles
</style>
